import React, { useState, useEffect } from 'react';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import moment from 'moment';

const Datepicker = ({ id, onDatesSelected, onRefreshSelected, fromDate, toDate }) => {
  const [startDate, setStartDate] = useState(fromDate ? moment(fromDate) : null);
  const [endDate, setEndDate] = useState(toDate ? moment(toDate) : null);
  const [focusedInput, setFocusedInput] = useState(null);

  // ✅ keep internal state in sync with props
  useEffect(() => {
    setStartDate(fromDate ? moment(fromDate) : null);
    setEndDate(toDate ? moment(toDate) : null);
  }, [fromDate, toDate]);

  const handleDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);

    if (startDate && endDate && onDatesSelected) {
      onDatesSelected(startDate, endDate);
    }
  };

  const renderCalendarInfo = () => (
    <div style={{ fontSize: "12px" }}>
      Selected:{" "}
      {startDate && endDate
        ? `${startDate.format("YYYY-MM-DD")} to ${endDate.format("YYYY-MM-DD")}`
        : "None"}
    </div>
  );

  return (
    <DateRangePicker
      startDate={startDate}
      endDate={endDate}
      onDatesChange={handleDatesChange}
      displayFormat="DD-MM-YYYY"
      focusedInput={focusedInput}
      onFocusChange={(focused) => setFocusedInput(focused)}
      minimumNights={0}
      isOutsideRange={() => false}
      readOnly={true}
      renderCalendarInfo={renderCalendarInfo}
      showDefaultInputIcon
    />
  );
};


export default Datepicker;
